import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Grid,
  TextField,
  makeStyles,
  Container,
  Button,
  CardContent,
  Divider,
  InputLabel,
  CardHeader,
  TableCell,
  TableRow,
  MenuItem,
  Typography,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableContainer
} from '@material-ui/core';
import MaterialTable from 'material-table';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from 'yup';
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import { useAlert } from 'react-alert';
import { startOfMonth, endOfMonth, addMonths } from 'date-fns';
import DateRangeSelectorComponent from '../../InquiryRegistry/Utils/DateRangeSelector';
import Popover from '@material-ui/core/Popover';
import EventIcon from '@material-ui/icons/Event';
import xlsx from 'json-as-xlsx';
import ReactToPrint from 'react-to-print';
import CreatePDF from './CreatePDF';
import moment from 'moment';
import { LoadingComponent } from './../../../../utils/newLoader';
import { Bold } from 'react-feather';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: 'red'
  },
  colorRecord: {
    backgroundColor: 'green'
  }
}));

const screenCode = 'ROUTEWISEFACTORYITEMDETAILREPORT';

const groupFactoryItems = (data) => {
  return data.reduce((routes, item) => {
    let routeGroup = routes.find((r) => r.routeName === item.routeName);
    if (!routeGroup) {
      routeGroup = { routeName: item.routeName, categories: [] };
      routes.push(routeGroup);
    }
    let categoryGroup = routeGroup.categories.find((c) => c.categoryName === item.categoryName);
    if (!categoryGroup) {
      categoryGroup = { categoryName: item.categoryName, items: [] };
      routeGroup.categories.push(categoryGroup);
    }
    categoryGroup.items.push(item);
    return routes;
  }, []);
};

const options = {
  style: 'decimal',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

export default function RouteWiseFactoryItemDetailReport(props) {
  const [title, setTitle] = useState("Route Wise Factory Item Detail Report");
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [routeList, setRouteList] = useState();
  const [ItemCategoryList, setItemCategoryList] = useState();
  const [factoryItems, setFactoryItems] = useState();
  const [itemRequestDetail, setItemRequestDetail] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    registrationNumber: '',
    itemCategoryID: 0,
    factoryItemID: 0,
    startDate: new Date().toISOString().substring(0, 10),
    endDate: new Date().toISOString().substring(0, 10)
  });
  const [factoryItemList, setFactoryItemList] = useState([]);
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: '0',
    factoryName: '0',
    startDate: '',
    endDate: '',
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const navigate = useNavigate();
  const alert = useAlert();
  const componentRef = useRef();
  const [csvHeaders, SetCsvHeaders] = useState([]);

  useEffect(() => {
    trackPromise(getPermission());
    trackPromise(getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(getFactoriesForDropdown());
  }, [itemRequestDetail.groupID]);

  useEffect(() => {
    trackPromise(getRoutesByFactoryID());
  }, [itemRequestDetail.factoryID]);

  useEffect(() => {
    trackPromise(getAllActiveItemCategory());
  }, []);

  useEffect(() => {
    trackPromise(getfactoryItemsForDropDown());
  }, [itemRequestDetail.groupID, itemRequestDetail.factoryID, itemRequestDetail.itemCategoryID]);

  useEffect(() => {
    setItemRequestDetail({
      ...itemRequestDetail,
      registrationNumber: '',
      itemCategoryID: 0,
      factoryItemID: 0
    });
  }, [itemRequestDetail.routeID]);

  useEffect(() => {
    setItemRequestDetail({
      ...itemRequestDetail,
      registrationNumber: '',
      factoryItemID: 0
    });
  }, [itemRequestDetail.itemCategoryID]);

  useEffect(() => {
    setItemRequestDetail({
      ...itemRequestDetail,
      registrationNumber: ''
    });
  }, [itemRequestDetail.factoryItemID]);

  
  useEffect(() => {
    setItemRequestDetail({
      ...itemRequestDetail,
      registrationNumber: '',
      itemCategoryID: 0,
      routeID: 0,
    });
  }, [itemRequestDetail.factoryID, itemRequestDetail.groupID]);
  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find((p) => p.permissionCode === 'VIEWROUTEWISEFACTORYITEMDETAILREPORT');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find((p) => p.permissionCode === 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find((p) => p.permissionCode === 'FACTORYDROPDOWN');

    setPermissions({
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
    });

    setItemRequestDetail({
      ...itemRequestDetail,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    });
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(itemRequestDetail.groupID);
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routes = await services.getRoutesForDropDown(itemRequestDetail.factoryID);
    setRouteList(routes);
  }

  async function getAllActiveItemCategory() {
    const result = await services.getAllActiveItemCategory();
    setItemCategoryList(result);
  }

  async function getfactoryItemsForDropDown() {
    const factoryItem = await services.getfactoryItemsByGroupIDFactoryIDItemCategoryID(
      itemRequestDetail.groupID,
      itemRequestDetail.factoryID,
      itemRequestDetail.itemCategoryID
    );
    setFactoryItems(factoryItem);
  }

  async function GetFactoryItemDetails() {
    let model = {
      groupID: parseInt(itemRequestDetail.groupID),
      factoryID: parseInt(itemRequestDetail.factoryID),
      routeID: parseInt(itemRequestDetail.routeID),
      itemCategoryID: parseInt(itemRequestDetail.itemCategoryID),
      factoryItemID: parseInt(itemRequestDetail.factoryItemID),
      registrationNumber: itemRequestDetail.registrationNumber,
      startDate: moment(itemRequestDetail.startDate.toString()).format().split('T')[0],
      endDate: moment(itemRequestDetail.endDate.toString()).format().split('T')[0]
    };
    getSelectedDropdownValuesForReport(model);

    const itemData = await services.GetFactoryItemDetailsForReport(model);

    if (itemData.statusCode === 'Success' && itemData.data != null) {
      setFactoryItemList(itemData.data);
      createDataForExcel(itemData.data);
      if (itemData.data.length === 0) {
        alert.error('No records to display');
      }
    } else {
      alert.error(itemData.message);
    }
  }

  async function createDataForExcel(array) {
    var res = [];
    let grandTotal = 0;
    let grandQuantityTotal = 0;

    if (array != null) {
      array.sort((a, b) => {
        if (a.routeName !== b.routeName) {
          return a.routeName.localeCompare(b.routeName);
        }
        return a.categoryName.localeCompare(b.categoryName);
      });

      let currentRoute = null;
      let routeTotal = 0;
      let routeQuantityTotal = 0;
      let categoryTotal = 0;
      let categoryQuantityTotal = 0;
      let currentCategory = null;

      array.forEach((x, index) => {
        if (currentRoute !== x.routeName) {
          if (currentRoute !== null) {
            if (categoryQuantityTotal > 0 || categoryTotal > 0) {
              res.push({
                'Route Name': "Total",
                'Quantity': categoryQuantityTotal,
                'Total Price (Rs)': parseFloat(categoryTotal.toFixed(2))
              });
            }
            grandTotal += routeTotal;
            grandQuantityTotal += routeQuantityTotal;
            res.push({});
          }
          currentRoute = x.routeName;
          routeTotal = 0;
          routeQuantityTotal = 0;
          categoryTotal = 0;
          categoryQuantityTotal = 0;
        }
        if (currentCategory !== null) {
          if (categoryQuantityTotal > 0 || categoryTotal > 0) {
            res.push({
              'Route Name': "Total",
              'Quantity': categoryQuantityTotal,
              'Total Price (Rs)': parseFloat(categoryTotal.toFixed(2))
            });
          }
          categoryTotal = 0;
          categoryQuantityTotal = 0;
          res.push({});
        }

        let vr = {
          'Route Name': x.routeName,
          'Date': x.date.split('T')[0],
          'Reg No': x.registrationNumber,
          'Supplier Name': x.name,
          'Category': x.categoryName,
          'Item': x.itemName,
          'No. of Installments': x.noOfInstallments.toLocaleString('en-US'),
          'Payment Effective Month': x.paymentEffectedMonth,
          'Unit Price	': parseFloat((x.totalPrice / x.approvedQuantity).toFixed(2)),
          'Quantity': x.approvedQuantity,
          'Total Price (Rs)': parseFloat(x.totalPrice.toFixed(2))
        };
        res.push(vr);

        routeTotal += x.totalPrice;
        categoryTotal += x.totalPrice;
        routeQuantityTotal += x.approvedQuantity;
        categoryQuantityTotal += x.approvedQuantity;

        if (index === array.length - 1) {
          if (categoryQuantityTotal > 0 || categoryTotal > 0) {
            res.push({
              'Route Name': "Total",
              'Quantity': categoryQuantityTotal,
              'Total Price (Rs)': parseFloat(categoryTotal.toFixed(2))
            });
          }
          grandTotal += routeTotal;
          grandQuantityTotal += routeQuantityTotal;
        }
      });

      res.push({});
      res.push({
        'Route Name': 'Group : ' + selectedSearchValues.groupName,
        'Date': 'Factory : ' + selectedSearchValues.factoryName
      });
      res.push({
        'Route Name': 'From Date : ' + selectedSearchValues.startDate,
        'Date': 'To Date : ' + selectedSearchValues.endDate
      });
      res.push({
        'Route Name': 'Route : ' + (selectedSearchValues.routeName && selectedSearchValues.routeName !== "0" ? selectedSearchValues.routeName : 'All Route'),
      });
    }

    return res;
  }

  async function createFile() {
    var file = await createDataForExcel(factoryItemList);
    var settings = {
      sheetName: 'Route Wise Factory Item Details',
      fileName: selectedSearchValues.routeName && selectedSearchValues.routeName !== "0"
                ? 'Route Wise Factory Item Detail Report - ' + 
                  selectedSearchValues.groupName + ' - ' +
                  selectedSearchValues.factoryName + ' - ' +
                  selectedSearchValues.routeName + ' - ' +
                  selectedSearchValues.startDate + ' To ' +
                  selectedSearchValues.endDate
                : 'Route Wise Factory Item Detail Report - ' + 
                  selectedSearchValues.groupName + ' - ' +
                  selectedSearchValues.factoryName + ' - ' +
                  'All Routes - ' + 
                  selectedSearchValues.startDate + ' To ' +
                  selectedSearchValues.endDate,
      writeOptions: {}
    };

    let keys = Object.keys(file[0]);
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem) => {
      tempcsvHeaders.push({ label: sitem, value: sitem });
    });

    let dataA = [
      {
        sheet: 'Route Wise Factory Item Details',
        columns: tempcsvHeaders,
        content: file
      }
    ];
    xlsx(dataA, settings);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value;
    setItemRequestDetail({
      ...itemRequestDetail,
      [e.target.name]: value
    });
    setFactoryItemList([]);
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    var startDate = moment(searchForm.startDate.toString()).format().split('T')[0];
    var endDate = moment(searchForm.endDate.toString()).format().split('T')[0];
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: GroupList[searchForm.groupID],
      factoryName: FactoryList[searchForm.factoryID],
      startDate: [startDate],
      endDate: [endDate],
      routeName: routeList[searchForm.routeID]
    });
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    );
  }

  const getPageMargins = () => {
    return `@media print {
            @page {
            background-color: white !important;
        }
        body {
            transform-origin: top left;
            background-color: white !important;
        }
    }`;
  };

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: itemRequestDetail.groupID,
              factoryID: itemRequestDetail.factoryID,
              startDate: itemRequestDetail.startDate,
              endDate: itemRequestDetail.endDate
            }}
            validationSchema={Yup.object().shape({
              groupID: Yup.number().required('Group is required').min(1, 'Group is required'),
              factoryID: Yup.number().required('Factory is required').min(1, 'Factory is required'),
              startDate: Yup.string(),
              endDate: Yup.string()
            })}
            onSubmit={() => trackPromise(GetFactoryItemDetails())}
            enableReinitialize
          >
            {({ errors, handleBlur, handleSubmit, touched }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={itemRequestDetail.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                              size="small"
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={itemRequestDetail.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                              size="small"
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="routeID">
                              Route
                            </InputLabel>
                            <TextField
                              select
                              fullWidth
                              name="routeID"
                              onChange={(e) => handleChange(e)}
                              value={itemRequestDetail.routeID}
                              variant="outlined"
                              id="routeID"
                              size="small"
                            >
                              <MenuItem value="0">--Select Route--</MenuItem>
                              {generateDropDownMenu(routeList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="itemCategoryID">
                              Item Category
                            </InputLabel>
                            <TextField
                              select
                              fullWidth
                              name="itemCategoryID"
                              onChange={(e) => handleChange(e)}
                              value={itemRequestDetail.itemCategoryID}
                              size="small"
                              variant="outlined"
                            >
                              <MenuItem value={0}>--Select Item Category--</MenuItem>
                              {generateDropDownMenu(ItemCategoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="factoryItemID">
                              Factory Item
                            </InputLabel>
                            <TextField
                              select
                              fullWidth
                              name="factoryItemID"
                              onChange={(e) => handleChange(e)}
                              value={itemRequestDetail.factoryItemID}
                              variant="outlined"
                              id="factoryItemID"
                              size="small"
                            >
                              <MenuItem value="0">--Select Factory Item--</MenuItem>
                              {generateDropDownMenu(factoryItems)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="registrationNumber">
                              Registration Number
                            </InputLabel>
                            <TextField
                              fullWidth
                              name="registrationNumber"
                              onChange={(e) => handleChange(e)}
                              value={itemRequestDetail.registrationNumber}
                              variant="outlined"
                              id="registrationNumber"
                              size="small"
                            />
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="startDate">
                              From Date *
                            </InputLabel>
                            <TextField
                              fullWidth
                              name="startDate"
                              type="date"
                              onChange={(e) => handleChange(e)}
                              value={itemRequestDetail.startDate}
                              variant="outlined"
                              id="startDate"
                              size="small"
                            />
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="endDate">
                              To Date *
                            </InputLabel>
                            <TextField
                              fullWidth
                              name="endDate"
                              type="date"
                              onChange={(e) => handleChange(e)}
                              value={itemRequestDetail.endDate}
                              variant="outlined"
                              id="endDate"
                              size="small"
                            />
                          </Grid>
                        </Grid>
                        <Box display="flex" flexDirection="row-reverse" p={2}>
                          <Button color="primary" type="submit" variant="contained" size="small">
                            Search
                          </Button>
                        </Box>
                      </CardContent>
                      <Box style={{ minWidth: 1050, padding: 3 }}>
                        {factoryItemList.length > 0 &&
                          groupFactoryItems(factoryItemList).map((routeGroup) => (
                            <Fragment key={routeGroup.routeName}>
                              <Typography variant="h5" style={{ fontWeight: "bold", color: "#333", marginBottom: 10 }}>
                                Route: {routeGroup.routeName}
                              </Typography>

                              {routeGroup.categories.map((categoryGroup) => {
                                const totalQuantity = categoryGroup.items.reduce((sum, item) => sum + item.approvedQuantity, 0);
                                const totalPrice = categoryGroup.items.reduce((sum, item) => sum + item.totalPrice, 0);

                                return (
                                  <Fragment key={categoryGroup.categoryName}>
                                    <Typography variant="h6" style={{ marginBottom: 10 }}>
                                      Category: {categoryGroup.categoryName}
                                    </Typography>

                                    <TableContainer component={Paper} style={{ marginBottom: 20 }}>
                                      <Table style={{ tableLayout: "fixed", width: "98%", margin: 'auto' }}>
                                        <TableHead>
                                          <TableRow>
                                              <TableCell style={{ width: '10%', textAlign: "left", fontWeight: 'bold'}}>Date</TableCell>
                                              <TableCell style={{ width: '8%', textAlign: "left", fontWeight: 'bold' }}>Reg No.</TableCell>
                                              <TableCell style={{ width: '10%', textAlign: "left", fontWeight: 'bold' }}>Supplier Name</TableCell>
                                              <TableCell style={{ width: '10%', textAlign: "center", fontWeight: 'bold' }}>Item</TableCell>
                                              <TableCell style={{ width: '10%', textAlign: "left", fontWeight: 'bold' }}>No. of Installments</TableCell>
                                              <TableCell style={{ width: '15%', textAlign: "left", fontWeight: 'bold'}}>Payment Effective Month</TableCell>
                                              <TableCell style={{ width: '8%', textAlign: "right", fontWeight: 'bold' }}>Unit Price</TableCell>
                                              <TableCell style={{ width: '8%', textAlign: "right", fontWeight: 'bold' }}>Quantity</TableCell>
                                              <TableCell style={{ width: '10%', textAlign: "right", fontWeight: 'bold' }}>Total Price (Rs)</TableCell>
                                          </TableRow>
                                        </TableHead>
                                        <TableBody>
                                          {categoryGroup.items.map((item, index) => (
                                            <TableRow key={index}>
                                              <TableCell style={{ textAlign: "left" }}>{item.date.split("T")[0]}</TableCell>
                                              <TableCell style={{ textAlign: "left" }}>{item.registrationNumber}</TableCell>
                                              <TableCell style={{ textAlign: "left" }}>{item.name}</TableCell>
                                              <TableCell style={{ textAlign: "center" }}>{item.itemName}</TableCell>
                                              <TableCell style={{ textAlign: "left" }}>{item.noOfInstallments}</TableCell>
                                              <TableCell style={{ textAlign: "left" }}>{item.paymentEffectedMonth}</TableCell>
                                              <TableCell style={{ textAlign: "right" }}>{Number(item.totalPrice/item.approvedQuantity).toLocaleString("en-US", { maximumFractionDigits: 2, minimumFractionDigits: 2 })}</TableCell>
                                              <TableCell style={{ textAlign: "right" }}>{item.approvedQuantity}</TableCell>
                                              <TableCell style={{ textAlign: "right" }}>
                                                {Number(item.totalPrice).toLocaleString("en-US", { minimumFractionDigits: 2 })}
                                              </TableCell>
                                            </TableRow>
                                          ))}

                                          <TableRow>
                                            <TableCell style={{ fontWeight: "bold", textAlign: "left" }}>Total</TableCell>
                                            <TableCell colSpan={6}></TableCell>
                                            <TableCell style={{ fontWeight: "bold", textAlign: "right" }}>{totalQuantity}</TableCell>
                                            <TableCell style={{ fontWeight: "bold", textAlign: "right" }}>{totalPrice.toFixed(2)}</TableCell>
                                          </TableRow>
                                        </TableBody>
                                      </Table>
                                    </TableContainer>
                                  </Fragment>
                                );
                              })}
                            </Fragment>
                          ))}
                      </Box>
                      {factoryItemList.length > 0 ? (
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={() => createFile()}
                            size="small"
                          >
                            EXCEL
                          </Button>
                          <ReactToPrint
                            documentTitle={selectedSearchValues.routeName && selectedSearchValues.routeName !== "0"?
                              'Route Wise Factory Item Detail Report - ' + 
                              selectedSearchValues.groupName + ' - ' +
                              selectedSearchValues.factoryName + ' - ' +
                              selectedSearchValues.routeName + ' - ' +
                              selectedSearchValues.startDate + ' To ' +
                              selectedSearchValues.endDate
                              :
                              'Route Wise Factory Item Detail Report - ' + 
                              selectedSearchValues.groupName + ' - ' +
                              selectedSearchValues.factoryName + ' - ' +
                              'All Routes - ' + 
                              selectedSearchValues.startDate + ' To ' +
                              selectedSearchValues.endDate
                            }
                            trigger={() => (
                              <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorCancel}
                                size="small"
                              >
                                PDF
                              </Button>
                            )}
                            pageStyle={getPageMargins()}
                            content={() => componentRef.current}
                          />
                          <div hidden={true}>
                            <CreatePDF ref={componentRef} factoryItemList={factoryItemList} searchData={selectedSearchValues} groupFactoryItems={groupFactoryItems}/>
                          </div>
                        </Box>
                      ) : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
